export default __webpack_public_path__ + "static/media/student_profile_pic.eacd3e5e.png";